export type Testimonial = {
  name: string;
  role: string;
  topic: string;
  quote: string;
  image: string;
};

export const testimonials: Testimonial[] = [
  {
    name: "Dr. Laura Méndez",
    role: "Dermatologist · Mexico",
    topic: "Assessment Framework",
    quote:
      "The five-stage framework gave my initial reviews a sequence I can actually repeat. I stopped jumping between history, pattern and trichoscopy notes — now everything lands on one worksheet in the same order every time.",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/d0f5ccfa-1b96-440e-ba9d-f0cb78700ab7.jpg",
  },
  {
    name: "Carlos Ríos",
    role: "Trichologist · Colombia",
    topic: "Trichoscopy Atlas",
    quote:
      "I used to keep trichoscopy images in five different folders. The atlas puts yellow dots, black dots, exclamation mark hairs and follicular openings side by side, which makes reviewing findings so much clearer.",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/12b256bf-9e17-45f8-b047-6f9f47c7a49e.jpg",
  },
  {
    name: "Dr. Sofía Herrera",
    role: "Dermatology Resident · Spain",
    topic: "Differential Diagnosis Resources",
    quote:
      "The diffuse and patchy hair loss flowcharts are what I open most. They help me organize considerations and document uncertainty before discussing a case with my attending.",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/92e0398c-5c5c-4235-87d1-bd3a99de1b85.jpg",
  },
  {
    name: "Dr. Richard Hale",
    role: "Hair Restoration Physician · United States",
    topic: "Clinical Case Library",
    quote:
      "The case library is excellent for structured study. Working through scenarios with the discussion questions is a far better use of my time than rereading isolated facts.",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/aa21e610-ff9f-42e2-9a24-02a5a360f7ce.jpg",
  },
  {
    name: "Andrea Paredes",
    role: "Trichology Professional · Chile",
    topic: "Documentation Tools",
    quote:
      "The documentation templates alone were worth it. History, photos, observations and follow-up questions now live in one consistent format I adapted to my practice in an afternoon.",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/9997a595-16f1-4d4b-8a89-69a9a60aaa2d.jpg",
  },
];
